import {
 Directive, ElementRef, HostListener, Renderer2, StaticProvider, forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const REMOVE_WHITESPACE_CONTROL_VALUE_ACCESSOR: StaticProvider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RemoveWhitespaceDirective),
    multi: true
};

// modfied version of numeric directive which is taken from https://stackblitz.com/edit/angular-input-field-to-accept-only-numbers-fzws1t?file=src%2Fapp%2Fonly-number.directive.ts
@Directive({
    selector: '[remove-whitespace]',
    providers: [REMOVE_WHITESPACE_CONTROL_VALUE_ACCESSOR],
    standalone: false
})
export class RemoveWhitespaceDirective implements ControlValueAccessor {
    private onChange: (val: string) => void;

    private onTouched: () => void;

    private value: string;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {
    }

    @HostListener('input', ['$event.target.value'])
    onInputChange(value: string) {
        const filteredValue: string = filterValue(value);
        this.updateTextInput(filteredValue, this.value !== filteredValue);
    }

    @HostListener('blur')
    onBlur() {
        if (this.onTouched) this.onTouched();
    }

    private updateTextInput(value: string, propagateChange: boolean) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
        if (propagateChange) {
            if (this.onChange) this.onChange(value);
        }
        this.value = value;
    }

    // ControlValueAccessor Interface
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    }

    writeValue(value: any): void {
        value = value ? String(value) : '';
        this.updateTextInput(value, false);
    }
}

function filterValue(value): string {
    return value.replace(/\s*/g, '');
}
